import { createSlice, PayloadAction } from '@reduxjs/toolkit';
export interface LoadingState {
  isLoading: boolean;
  changeDutyStatus: boolean;
}
const initialState = {
  isLoading: false,
  changeDutyStatus: false,
};
export const reducerSlice = createSlice({
  name: 'loadingReducer',
  initialState,
  reducers: {
    startLoading: (state): void => {
      state.isLoading = true;
    },
    stopLoading: (state): void => {
      state.isLoading = false;
    },
    setChangeDutyStatus: (state, action: PayloadAction<boolean>): void => {
      state.changeDutyStatus = action.payload;
    },
  },
});

export const { startLoading, stopLoading, setChangeDutyStatus } = reducerSlice.actions;

export default reducerSlice.reducer;
